module.exports = __webpack_public_path__ + "assets/img/13-18.0722dc83.svg";